import React  from "react";
import './table.scss'
import 'chart.js/auto';
import { Table } from "react-bootstrap";


export default function TableCus({ChartList,Questionlist}) {
  return (
    <div className="feature">
        <div className="row">
        {Questionlist.map((entry, index) => (
          <h5 className="title">คำถาม : {entry.name}</h5>
          ))}
          <Table striped bordered hover  responsive="md" >
            <thead>
              <tr>
                <th style={{ "textAlign": "center","verticalAlign": "middle" }} >ตัวเลือกคำตอบ</th>
                <th style={{ "textAlign": "center","verticalAlign": "middle" }} >จำนวน</th>
                <th style={{ "textAlign": "center","verticalAlign": "middle" }} >ร้อยละ</th>
              </tr>
            </thead>
            <tbody>
              {ChartList.map((entry, index) => (
                <tr key={index}>
                  <td style={{ "textAlign": "center","verticalAlign": "middle" }}>{entry.Des}</td>
                  <td style={{ "textAlign": "center","verticalAlign": "middle" }}>{entry.value}</td>
                  <td style={{ "textAlign": "center","verticalAlign": "middle" }}>{entry.allvalue}</td>
          
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
  )
}